import { useEffect } from 'react';
import {
    CircleMarker,
    MapContainer,
    Polyline,
    TileLayer,
    Tooltip,
    useMap,
} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

const FitRouteBounds = ({
    positions,
}) => {
    const map = useMap();

    useEffect(() => {
        map.fitBounds(positions, {
            padding: [30, 30],
        });
    }, [
        map,
        positions,
    ]);

    return null;
};

const RouteMap = ({
    origin,
    destination,
}) => {
    const positions = [
        origin.coordinates,
        destination.coordinates,
    ];

    return (
        <MapContainer
            className="freight-route-map"
            center={origin.coordinates}
            scrollWheelZoom={false}
            zoom={6}
        >
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            <Polyline
                pathOptions={{
                    color: '#556EE6',
                    dashArray: '8 8',
                    weight: 3,
                }}
                positions={positions}
            />

            <CircleMarker
                center={origin.coordinates}
                pathOptions={{
                    color: '#FFFFFF',
                    fillColor: '#556EE6',
                    fillOpacity: 1,
                    weight: 2,
                }}
                radius={7}
            >
                <Tooltip direction="top" permanent>
                    {origin.city}
                </Tooltip>
            </CircleMarker>

            <CircleMarker
                center={destination.coordinates}
                pathOptions={{
                    color: '#FFFFFF',
                    fillColor: '#556EE6',
                    fillOpacity: 1,
                    weight: 2,
                }}
                radius={7}
            >
                <Tooltip direction="top" permanent>
                    {destination.city}
                </Tooltip>
            </CircleMarker>

            <FitRouteBounds positions={positions} />
        </MapContainer>
    );
};

export default RouteMap;
